module.exports = __webpack_public_path__ + "img/shipo-menu-barge-line-up-white.c3dd36ef.svg";